import styles from '../Dashboard.module.css';

// Helper function to get status icon class
export const getStatusIconClass = (status) => {
  switch (status) {
    case 'extra-credit': return styles.summaryItemIcon + ' ' + styles.extraCredit;
    case 'pending': return styles.summaryItemIcon + ' ' + styles.pending;
    case 'overdue': return styles.summaryItemIcon + ' ' + styles.overdue;
    case 'completed': return styles.summaryItemIcon + ' ' + styles.completed;
    case 'in-progress': return styles.summaryItemIcon + ' ' + styles.inProgress;
    default: return styles.summaryItemIcon + ' ' + styles.pending;
  }
};
